const algoliaSearch = require('algoliasearch');
import { siteConfig } from '../../config/algolia';

// Import instant search, widgets and connectors
import instantsearch from 'instantsearch.js'
import { connectHits } from 'instantsearch.js/es/connectors'
import { searchBox, configure, index as algoliaIndex, pagination, stats } from 'instantsearch.js/es/widgets'

export default ($el) => ({
    results: [],
    el: $el,
    noResults: true,
    hasQuery: false,
    init() {
        this.algoliaSearch()
    },
    algoliaSearch() {
        console.log('loading algolia')
        const appId = siteConfig.app_id;
        const apiKey = siteConfig.api_key;
        const algoliaClient = algoliaSearch(appId, apiKey);

        const search = instantsearch({
            indexName: siteConfig.index,
            searchClient: algoliaClient,
        });

        const self = this; // reference to the Alpine.js component

        search.on('render', () => {
            const helper = search.helper;
            self.hasQuery = helper.state.query !== '';
        });

        const structuredResults = connectHits(({ hits }) => {
            if (hits.length) {
                self.noResults = false
                self.results = hits
            } else {
                self.noResults = true
                self.results = []
            }
        });

        search.addWidgets([
          searchBox({
            container: '[data-widget="search-box"]',
            autofocus: true,
            showReset: false,
            showSubmit: false,
            cssClasses: {
                root: 'w-full',
                form: 'w-full',
                input:'px-5 py-3 border-2 border-blue-500 w-full',
            },
          }),
            pagination({
                container: '[data-pagination]',
                showFirst: false,
                showLast: false,
                cssClasses: {
                    list: 'pagination',
                    item: 'pagination__item',
                    link: 'pagination__link',
                    nextPageItem: 'pagination__item--next',
                    previousPageItem: 'pagination__item--previous',
                    disabledItem: 'pagination__item--disabled',
                },
                templates: {
                    next: 'Next ›',
                    previous: '‹ Previous',
                },
            }),
            configure({
                hitsPerPage: 30,
                distinct: true
            }),
            structuredResults(),
        ])

        search.start();
    }
});
